// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gh-issue {
  --gh-bg: #ffffff;
  --gh-canvas-subtle: #f6f8fa;
  --gh-border: #d0d7de;
  --gh-border-muted: #d8dee4;
  --gh-text: #1f2328;
  --gh-text-muted: #59636e;
  --gh-link: #0969da;
  --gh-open: #1f883d;
  --gh-open-bg: #dafbe1;
  --gh-closed: #8250df;
  --gh-closed-bg: #fbefff;
  --gh-btn-bg: #f6f8fa;
  --gh-btn-hover: #eef1f4;
  --gh-danger: #cf222e;
  color: var(--gh-text);
  font-size: 14px;
  line-height: 1.5;
  background: var(--gh-bg);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;
}
.gh-issue a {
  color: var(--gh-link);
  text-decoration: none;
}
.gh-issue a:hover {
  text-decoration: underline;
}
.gh-issue__header {
  padding: 16px 24px 12px;
  border-bottom: 1px solid var(--gh-border);
  background: var(--gh-bg);
}
.gh-issue__title-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 8px;
}
.gh-issue__title {
  flex: 1 1;
  font-size: 24px;
  font-weight: 400;
  color: var(--gh-text);
  line-height: 1.25;
  word-break: break-word;
  cursor: pointer;
}
.gh-issue__title .ghi-code {
  color: var(--gh-text-muted);
  font-weight: 300;
  margin-left: 6px;
}
.gh-issue__title-edit {
  display: flex;
  gap: 8px;
  flex: 1 1;
}
.gh-issue__title-edit input {
  flex: 1 1;
  padding: 6px 10px;
  font-size: 16px;
  border: 1px solid var(--gh-border);
  border-radius: 6px;
  color: var(--gh-text);
}
.gh-issue__title-edit input:focus {
  outline: none;
  border-color: var(--gh-link);
  box-shadow: 0 0 0 3px rgba(9, 105, 218, 0.2);
}
.gh-issue__title-btns {
  display: flex;
  gap: 6px;
  align-self: flex-start;
}
.gh-issue__meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  color: var(--gh-text-muted);
  font-size: 14px;
}
.gh-issue__badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 2em;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}
.gh-issue__badge.is-open {
  background: #1f883d;
}
.gh-issue__badge.is-closed {
  background: #8250df;
}
.gh-issue__body {
  display: grid;
  grid-template-columns: 1fr 280px;
  gap: 24px;
  padding: 16px 24px 24px;
}
@media (max-width: 960px) {
  .gh-issue__body {
    grid-template-columns: 1fr;
  }
}
.gh-issue__main {
  min-width: 0;
}
.gh-issue__sidebar {
  min-width: 0;
}
.gh-issue__sidebar .ghi-side-section {
  padding: 12px 0;
  border-bottom: 1px solid var(--gh-border-muted);
}
.gh-issue__sidebar .ghi-side-section:first-child {
  padding-top: 0;
}
.gh-issue__sidebar .ghi-side-section:last-child {
  border-bottom: none;
}
.gh-issue__sidebar .ghi-side-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: var(--gh-text-muted);
  font-weight: 600;
  margin-bottom: 8px;
  cursor: pointer;
}
.gh-issue__sidebar .ghi-side-title:hover {
  color: var(--gh-link);
}
.gh-issue__sidebar .ghi-side-title .ghi-gear {
  opacity: 0.7;
}
.gh-issue__sidebar .ghi-side-body {
  color: var(--gh-text);
  font-size: 13px;
}
.gh-issue__sidebar .ghi-side-empty {
  color: var(--gh-text-muted);
  font-size: 12px;
}
.gh-issue__card {
  border: 1px solid var(--gh-border);
  border-radius: 6px;
  background: var(--gh-bg);
  margin-bottom: 16px;
  overflow: hidden;
}
.gh-issue__card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--gh-canvas-subtle);
  border-bottom: 1px solid var(--gh-border);
  font-size: 13px;
  color: var(--gh-text);
}
.gh-issue__card-head .ghi-author {
  font-weight: 600;
}
.gh-issue__card-head .ghi-time {
  color: var(--gh-text-muted);
}
.gh-issue__card-head .ghi-author-badge {
  margin-left: 6px;
  font-size: 11px;
  padding: 1px 7px;
  border-radius: 2em;
  border: 1px solid var(--gh-border);
  color: var(--gh-text-muted);
}
.gh-issue__card-head .ghi-head-actions {
  margin-left: auto;
  display: flex;
  gap: 6px;
  color: var(--gh-text-muted);
}
.gh-issue__card-head .ghi-head-btn {
  background: transparent;
  border: none;
  color: inherit;
  padding: 2px 6px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}
.gh-issue__card-head .ghi-head-btn:hover {
  background: rgba(208, 215, 222, 0.4);
  color: var(--gh-text);
}
.gh-issue__card-body {
  padding: 12px 16px;
  color: var(--gh-text);
  font-size: 14px;
  word-break: break-word;
}
.gh-issue__card-body.is-empty {
  color: var(--gh-text-muted);
  font-style: italic;
}
.gh-issue__card-body p {
  margin: 0 0 8px;
}
.gh-issue__card-body ul, .gh-issue__card-body ol {
  margin: 0 0 8px;
  padding-left: 22px;
}
.gh-issue__card-body img {
  max-width: 100%;
}
.gh-issue__event {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  color: var(--gh-text-muted);
  font-size: 13px;
  position: relative;
  padding-left: 40px;
}
.gh-issue__event::before {
  content: "";
  position: absolute;
  left: 15px;
  top: 0;
  bottom: -10px;
  width: 2px;
  background: var(--gh-border);
}
.gh-issue__event .ghi-event-icon {
  position: absolute;
  left: 6px;
  top: 8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--gh-canvas-subtle);
  border: 1px solid var(--gh-border);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: var(--gh-text-muted);
}
.gh-issue__event .ghi-event-author {
  color: var(--gh-text);
  font-weight: 600;
}
.gh-issue__composer {
  border: 1px solid var(--gh-border);
  border-radius: 6px;
  background: var(--gh-bg);
  margin-top: 16px;
  overflow: hidden;
}
.gh-issue__composer-tabs {
  display: flex;
  gap: 0;
  padding: 6px 6px 0;
  background: var(--gh-canvas-subtle);
  border-bottom: 1px solid var(--gh-border);
}
.gh-issue__composer-tab {
  padding: 6px 14px;
  background: transparent;
  border: 1px solid transparent;
  border-bottom: none;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  color: var(--gh-text-muted);
  font-size: 13px;
  cursor: pointer;
}
.gh-issue__composer-tab.is-active {
  background: var(--gh-bg);
  border-color: var(--gh-border);
  color: var(--gh-text);
  font-weight: 600;
}
.gh-issue__composer-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  padding: 4px 8px;
  border-bottom: 1px solid var(--gh-border-muted);
  background: var(--gh-bg);
}
.gh-issue__composer-toolbar .ghi-tb-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--gh-text-muted);
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
}
.gh-issue__composer-toolbar .ghi-tb-btn:hover {
  background: var(--gh-canvas-subtle);
  color: var(--gh-text);
}
.gh-issue__composer-toolbar .ghi-tb-sep {
  width: 1px;
  background: var(--gh-border-muted);
  margin: 4px 4px;
}
.gh-issue__composer-body {
  padding: 12px;
  position: relative;
}
.gh-issue__composer-body.is-dragover {
  outline: 2px dashed var(--gh-link);
  outline-offset: -6px;
  background: rgba(9, 105, 218, 0.05);
}
.gh-issue__composer-body textarea {
  width: 100%;
  min-height: 120px;
  resize: vertical;
  padding: 8px 10px;
  border: 1px solid var(--gh-border);
  border-radius: 6px;
  font-size: 14px;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace;
  color: var(--gh-text);
  background: #fff;
}
.gh-issue__composer-body textarea:focus {
  outline: none;
  border-color: var(--gh-link);
  box-shadow: 0 0 0 3px rgba(9, 105, 218, 0.2);
}
.gh-issue__composer-hint {
  padding: 6px 12px 0;
  font-size: 12px;
  color: var(--gh-text-muted);
}
.gh-issue__composer-hint code {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  background: var(--gh-canvas-subtle);
  padding: 1px 4px;
  border-radius: 3px;
}
.gh-issue__md {
  word-break: break-word;
}
.gh-issue__md h1, .gh-issue__md h2 {
  border-bottom: 1px solid var(--gh-border-muted);
  padding-bottom: 6px;
  margin-top: 16px;
}
.gh-issue__md h1 {
  font-size: 1.8em;
}
.gh-issue__md h2 {
  font-size: 1.4em;
}
.gh-issue__md h3 {
  font-size: 1.2em;
}
.gh-issue__md p {
  margin: 0 0 10px;
}
.gh-issue__md ul, .gh-issue__md ol {
  padding-left: 22px;
  margin: 0 0 10px;
}
.gh-issue__md li input[type=checkbox] {
  margin-right: 6px;
}
.gh-issue__md blockquote {
  margin: 0 0 10px;
  padding: 0 12px;
  color: var(--gh-text-muted);
  border-left: 3px solid var(--gh-border);
}
.gh-issue__md code {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  background: var(--gh-canvas-subtle);
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 0.9em;
}
.gh-issue__md pre {
  background: var(--gh-canvas-subtle);
  padding: 12px;
  border-radius: 6px;
  overflow-x: auto;
  font-size: 0.9em;
}
.gh-issue__md pre code {
  background: transparent;
  padding: 0;
}
.gh-issue__md table {
  border-collapse: collapse;
  margin: 0 0 10px;
}
.gh-issue__md table th, .gh-issue__md table td {
  border: 1px solid var(--gh-border);
  padding: 4px 10px;
}
.gh-issue__md table th {
  background: var(--gh-canvas-subtle);
}
.gh-issue__md img {
  max-width: 100%;
}
.gh-issue__md a {
  color: var(--gh-link);
}
.gh-issue__md hr {
  border: none;
  border-top: 1px solid var(--gh-border);
  margin: 16px 0;
}
.gh-issue__composer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 0 12px 12px;
}
.gh-issue__composer-attach {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 8px 12px;
  border-top: 1px dashed var(--gh-border-muted);
  background: var(--gh-canvas-subtle);
  font-size: 12px;
  color: var(--gh-text-muted);
}
.gh-issue__composer-attach-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.gh-issue__composer-attach-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  background: #fff;
  border: 1px solid var(--gh-border);
  border-radius: 4px;
  font-size: 12px;
  color: var(--gh-text);
}
.gh-issue__composer-attach-item a {
  color: var(--gh-link);
}
.gh-issue__composer-attach-thumb {
  display: inline-block;
  border: 1px solid var(--gh-border);
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}
.gh-issue__composer-attach-thumb img {
  display: block;
  max-width: 140px;
  max-height: 100px;
  object-fit: cover;
}
.gh-issue__composer-attach-thumb:hover {
  border-color: var(--gh-link);
}
.gh-issue .ghi-att-thumb {
  display: inline-block;
  border: 1px solid var(--gh-border);
  border-radius: 4px;
  overflow: hidden;
  line-height: 0;
}
.gh-issue .ghi-att-thumb img {
  display: block;
  max-width: 40px;
  max-height: 40px;
  object-fit: cover;
}
.gh-issue__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid var(--gh-border);
  background: var(--gh-btn-bg);
  color: var(--gh-text);
  line-height: 1.5;
}
.gh-issue__btn:hover {
  background: var(--gh-btn-hover);
}
.gh-issue__btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.gh-issue__btn.is-primary {
  background: #1f883d;
  color: #fff;
  border-color: rgba(27, 31, 36, 0.15);
}
.gh-issue__btn.is-primary:hover {
  background: #1a7f37;
}
.gh-issue__btn.is-purple {
  background: #8250df;
  color: #fff;
  border-color: rgba(27, 31, 36, 0.15);
}
.gh-issue__btn.is-purple:hover {
  background: #6e40c9;
}
.gh-issue__btn.is-danger {
  color: var(--gh-danger);
}
.gh-issue__btn.is-danger:hover {
  background: #ffebe9;
  border-color: #ffcecb;
}
.gh-issue .ghi-label {
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  height: 22px;
  border-radius: 2em;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid transparent;
  white-space: nowrap;
  margin: 2px 4px 2px 0;
}
.gh-issue .ghi-assignee-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}
.gh-issue .ghi-assignee-row .ghi-assignee-name {
  font-size: 13px;
  color: var(--gh-text);
}
.gh-issue .ghi-checklist-item {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 4px 0;
  font-size: 13px;
}
.gh-issue .ghi-checklist-item label {
  cursor: pointer;
}
.gh-issue .ghi-checklist-item .is-done {
  text-decoration: line-through;
  color: var(--gh-text-muted);
}
.gh-issue .ghi-attachment {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  font-size: 13px;
  color: var(--gh-link);
}
.gh-issue .ghi-attachment a {
  color: inherit;
}
.gh-issue .ghi-attachment .ghi-att-del {
  margin-left: auto;
  color: var(--gh-text-muted);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0 4px;
}
.gh-issue .ghi-attachment .ghi-att-del:hover {
  color: var(--gh-danger);
}

.gh-issue .mention {
  background: #ddf4ff;
  color: #0969da;
  padding: 0 4px;
  border-radius: 4px;
  font-weight: 600;
  text-decoration: none;
  display: inline-block;
  line-height: 1.4;
}
.gh-issue .mention:hover {
  background: #b6e3ff;
  text-decoration: none;
}

.cke_autocomplete_panel {
  background: #fff;
  border: 1px solid #d0d7de;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(140, 149, 159, 0.2);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;
  min-width: 220px;
  max-height: 240px;
  overflow-y: auto;
  padding: 4px 0;
  z-index: 10010;
}

.ck-mention-item {
  list-style: none;
  padding: 6px 12px;
  font-size: 13px;
  color: #1f2328;
  cursor: pointer;
}
.ck-mention-item.cke_autocomplete_selected, .ck-mention-item:hover {
  background: #ddf4ff;
  color: #0969da;
}
.ck-mention-item .ck-mention-avatar {
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/ProjectBoard/TaskIssueDrawer.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,2BAAA;EACA,oBAAA;EACA,0BAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EAEA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,wFAAA;AAAF;AAEE;EAAI,qBAAA;EAAuB,qBAAA;AAE7B;AAFoD;EAAU,0BAAA;AAK9D;AAHE;EACE,uBAAA;EACA,yCAAA;EACA,wBAAA;AAKJ;AAFE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;AAIJ;AADE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;AAGJ;AADI;EACE,2BAAA;EACA,gBAAA;EACA,gBAAA;AAGN;AACE;EACE,aAAA;EACA,QAAA;EACA,SAAA;AACJ;AACI;EACE,SAAA;EACA,iBAAA;EACA,eAAA;EACA,kCAAA;EACA,kBAAA;EACA,qBAAA;AACN;AACM;EACE,aAAA;EACA,4BAAA;EACA,4CAAA;AACR;AAIE;EACE,aAAA;EACA,QAAA;EACA,sBAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,2BAAA;EACA,eAAA;AAHJ;AAME;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAJJ;AAMI;EAAY,mBAAA;AAHhB;AAII;EAAc,mBAAA;AADlB;AAIE;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,uBAAA;AAFJ;AAII;EANF;IAOI,0BAAA;EADJ;AACF;AAIE;EAAU,YAAA;AADZ;AAGE;EACE,YAAA;AADJ;AAGI;EACE,eAAA;EACA,+CAAA;AADN;AAGM;EAAgB,cAAA;AAAtB;AACM;EAAe,mBAAA;AAErB;AACI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AACN;AACM;EAAU,qBAAA;AAEhB;AAAM;EAAY,YAAA;AAGlB;AAAI;EACE,qBAAA;EACA,eAAA;AAEN;AACI;EAAkB,2BAAA;EAA6B,eAAA;AAGnD;AAAE;EACE,kCAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;AAEJ;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mCAAA;EACA,yCAAA;EACA,eAAA;EACA,qBAAA;AACJ;AACI;EAAc,gBAAA;AAElB;AADI;EAAY,2BAAA;AAIhB;AAFI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kCAAA;EACA,2BAAA;AAIN;AADI;EACE,iBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;AAGN;AAAI;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAEN;AAAM;EAAU,oCAAA;EAAsC,qBAAA;AAItD;AAAE;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,sBAAA;AAEJ;AAAI;EAAa,2BAAA;EAA6B,kBAAA;AAI9C;AAFI;EAAI,eAAA;AAKR;AAJI;EAAS,eAAA;EAAiB,kBAAA;AAQ9B;AAPI;EAAM,eAAA;AAUV;AAPE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AASJ;AAPI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,aAAA;EACA,UAAA;EACA,4BAAA;AASN;AANI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,kCAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,2BAAA;AAQN;AALI;EAAoB,qBAAA;EAAuB,gBAAA;AAS/C;AANE;EACE,kCAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;AAQJ;AALE;EACE,aAAA;EACA,MAAA;EACA,kBAAA;EACA,mCAAA;EACA,yCAAA;AAOJ;AAJE;EACE,iBAAA;EACA,uBAAA;EACA,6BAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;EACA,2BAAA;EACA,eAAA;EACA,eAAA;AAMJ;AAJI;EACE,wBAAA;EACA,8BAAA;EACA,qBAAA;EACA,gBAAA;AAMN;AAFE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;EACA,+CAAA;EACA,wBAAA;AAIJ;AAFI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAIN;AAFM;EAAU,mCAAA;EAAqC,qBAAA;AAMrD;AAHI;EACE,UAAA;EACA,kCAAA;EACA,eAAA;AAKN;AADE;EACE,aAAA;EACA,kBAAA;AAGJ;AADI;EACE,kCAAA;EACA,oBAAA;EACA,mCAAA;AAGN;AAAI;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,mGAAA;EACA,qBAAA;EACA,gBAAA;AAEN;AAAM;EACE,aAAA;EACA,4BAAA;EACA,4CAAA;AAER;AAGE;EACE,mBAAA;EACA,eAAA;EACA,2BAAA;AADJ;AAGI;EACE,2DAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;AADN;AAKE;EACE,sBAAA;AAHJ;AAKI;EAAS,+CAAA;EAAiD,mBAAA;EAAqB,gBAAA;AAAnF;AACI;EAAK,gBAAA;AAET;AADI;EAAK,gBAAA;AAIT;AAHI;EAAK,gBAAA;AAMT;AALI;EAAI,gBAAA;AAQR;AAPI;EAAS,kBAAA;EAAoB,gBAAA;AAWjC;AAVI;EAA4B,iBAAA;AAahC;AAZI;EACE,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,uCAAA;AAcN;AAZI;EACE,2DAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAcN;AAZI;EACE,mCAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAcN;AAZM;EAAO,uBAAA;EAAyB,UAAA;AAgBtC;AAdI;EACE,yBAAA;EACA,gBAAA;AAgBN;AAdM;EACE,kCAAA;EACA,iBAAA;AAgBR;AAdM;EAAK,mCAAA;AAiBX;AAfI;EAAM,eAAA;AAkBV;AAjBI;EAAI,qBAAA;AAoBR;AAnBI;EAAK,YAAA;EAAc,sCAAA;EAAwC,cAAA;AAwB/D;AArBE;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,oBAAA;AAuBJ;AApBE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;EACA,6CAAA;EACA,mCAAA;EACA,eAAA;EACA,2BAAA;AAsBJ;AAnBE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAqBJ;AAlBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AAoBJ;AAlBI;EAAI,qBAAA;AAqBR;AAlBE;EACE,qBAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAoBJ;AAlBI;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAoBN;AAjBI;EAAU,4BAAA;AAoBd;AAjBE;EACE,qBAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAmBJ;AAjBI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAmBN;AAfE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kCAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;AAiBJ;AAfI;EAAU,+BAAA;AAkBd;AAjBI;EAAa,YAAA;EAAc,mBAAA;AAqB/B;AAnBI;EACE,mBAAA;EACA,WAAA;EACA,oCAAA;AAqBN;AAnBM;EAAU,mBAAA;AAsBhB;AAnBI;EACE,mBAAA;EACA,WAAA;EACA,oCAAA;AAqBN;AAnBM;EAAU,mBAAA;AAsBhB;AAnBI;EACE,uBAAA;AAqBN;AAnBM;EAAU,mBAAA;EAAqB,qBAAA;AAuBrC;AAnBE;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,qBAAA;AAqBJ;AAlBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAoBJ;AAlBI;EACE,eAAA;EACA,qBAAA;AAoBN;AAhBE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AAkBJ;AAhBI;EAAQ,eAAA;AAmBZ;AAlBI;EAAW,6BAAA;EAA+B,2BAAA;AAsB9C;AAnBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AAqBJ;AAnBI;EAAI,cAAA;AAsBR;AApBI;EACE,iBAAA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAsBN;AApBM;EAAU,uBAAA;AAuBhB;;AAhBE;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AAmBJ;AAjBI;EAAU,mBAAA;EAAqB,qBAAA;AAqBnC;;AAfA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,+CAAA;EACA,wFAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAkBF;;AAfA;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAkBF;AAhBE;EAEE,mBAAA;EACA,cAAA;AAiBJ;AAdE;EACE,gBAAA;AAgBJ","sourcesContent":[".gh-issue {\n  --gh-bg: #ffffff;\n  --gh-canvas-subtle: #f6f8fa;\n  --gh-border: #d0d7de;\n  --gh-border-muted: #d8dee4;\n  --gh-text: #1f2328;\n  --gh-text-muted: #59636e;\n  --gh-link: #0969da;\n  --gh-open: #1f883d;\n  --gh-open-bg: #dafbe1;\n  --gh-closed: #8250df;\n  --gh-closed-bg: #fbefff;\n  --gh-btn-bg: #f6f8fa;\n  --gh-btn-hover: #eef1f4;\n  --gh-danger: #cf222e;\n\n  color: var(--gh-text);\n  font-size: 14px;\n  line-height: 1.5;\n  background: var(--gh-bg);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;\n\n  a { color: var(--gh-link); text-decoration: none; &:hover { text-decoration: underline; } }\n\n  &__header {\n    padding: 16px 24px 12px;\n    border-bottom: 1px solid var(--gh-border);\n    background: var(--gh-bg);\n  }\n\n  &__title-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    margin-bottom: 8px;\n  }\n\n  &__title {\n    flex: 1;\n    font-size: 24px;\n    font-weight: 400;\n    color: var(--gh-text);\n    line-height: 1.25;\n    word-break: break-word;\n    cursor: pointer;\n\n    .ghi-code {\n      color: var(--gh-text-muted);\n      font-weight: 300;\n      margin-left: 6px;\n    }\n  }\n\n  &__title-edit {\n    display: flex;\n    gap: 8px;\n    flex: 1;\n\n    input {\n      flex: 1;\n      padding: 6px 10px;\n      font-size: 16px;\n      border: 1px solid var(--gh-border);\n      border-radius: 6px;\n      color: var(--gh-text);\n\n      &:focus {\n        outline: none;\n        border-color: var(--gh-link);\n        box-shadow: 0 0 0 3px rgba(9,105,218,0.2);\n      }\n    }\n  }\n\n  &__title-btns {\n    display: flex;\n    gap: 6px;\n    align-self: flex-start;\n  }\n\n  &__meta {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n    color: var(--gh-text-muted);\n    font-size: 14px;\n  }\n\n  &__badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 5px 12px;\n    border-radius: 2em;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 500;\n\n    &.is-open { background: #1f883d; }\n    &.is-closed { background: #8250df; }\n  }\n\n  &__body {\n    display: grid;\n    grid-template-columns: 1fr 280px;\n    gap: 24px;\n    padding: 16px 24px 24px;\n\n    @media (max-width: 960px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__main { min-width: 0; }\n\n  &__sidebar {\n    min-width: 0;\n\n    .ghi-side-section {\n      padding: 12px 0;\n      border-bottom: 1px solid var(--gh-border-muted);\n\n      &:first-child { padding-top: 0; }\n      &:last-child { border-bottom: none; }\n    }\n\n    .ghi-side-title {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      font-size: 12px;\n      color: var(--gh-text-muted);\n      font-weight: 600;\n      margin-bottom: 8px;\n      cursor: pointer;\n\n      &:hover { color: var(--gh-link); }\n\n      .ghi-gear { opacity: 0.7; }\n    }\n\n    .ghi-side-body {\n      color: var(--gh-text);\n      font-size: 13px;\n    }\n\n    .ghi-side-empty { color: var(--gh-text-muted); font-size: 12px; }\n  }\n\n  &__card {\n    border: 1px solid var(--gh-border);\n    border-radius: 6px;\n    background: var(--gh-bg);\n    margin-bottom: 16px;\n    overflow: hidden;\n  }\n\n  &__card-head {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 16px;\n    background: var(--gh-canvas-subtle);\n    border-bottom: 1px solid var(--gh-border);\n    font-size: 13px;\n    color: var(--gh-text);\n\n    .ghi-author { font-weight: 600; }\n    .ghi-time { color: var(--gh-text-muted); }\n\n    .ghi-author-badge {\n      margin-left: 6px;\n      font-size: 11px;\n      padding: 1px 7px;\n      border-radius: 2em;\n      border: 1px solid var(--gh-border);\n      color: var(--gh-text-muted);\n    }\n\n    .ghi-head-actions {\n      margin-left: auto;\n      display: flex;\n      gap: 6px;\n      color: var(--gh-text-muted);\n    }\n\n    .ghi-head-btn {\n      background: transparent;\n      border: none;\n      color: inherit;\n      padding: 2px 6px;\n      border-radius: 4px;\n      cursor: pointer;\n      font-size: 12px;\n\n      &:hover { background: rgba(208, 215, 222, 0.4); color: var(--gh-text); }\n    }\n  }\n\n  &__card-body {\n    padding: 12px 16px;\n    color: var(--gh-text);\n    font-size: 14px;\n    word-break: break-word;\n\n    &.is-empty { color: var(--gh-text-muted); font-style: italic; }\n\n    p { margin: 0 0 8px; }\n    ul, ol { margin: 0 0 8px; padding-left: 22px; }\n    img { max-width: 100%; }\n  }\n\n  &__event {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 0;\n    color: var(--gh-text-muted);\n    font-size: 13px;\n    position: relative;\n    padding-left: 40px;\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: 15px;\n      top: 0;\n      bottom: -10px;\n      width: 2px;\n      background: var(--gh-border);\n    }\n\n    .ghi-event-icon {\n      position: absolute;\n      left: 6px;\n      top: 8px;\n      width: 20px;\n      height: 20px;\n      border-radius: 50%;\n      background: var(--gh-canvas-subtle);\n      border: 1px solid var(--gh-border);\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 11px;\n      color: var(--gh-text-muted);\n    }\n\n    .ghi-event-author { color: var(--gh-text); font-weight: 600; }\n  }\n\n  &__composer {\n    border: 1px solid var(--gh-border);\n    border-radius: 6px;\n    background: var(--gh-bg);\n    margin-top: 16px;\n    overflow: hidden;\n  }\n\n  &__composer-tabs {\n    display: flex;\n    gap: 0;\n    padding: 6px 6px 0;\n    background: var(--gh-canvas-subtle);\n    border-bottom: 1px solid var(--gh-border);\n  }\n\n  &__composer-tab {\n    padding: 6px 14px;\n    background: transparent;\n    border: 1px solid transparent;\n    border-bottom: none;\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n    color: var(--gh-text-muted);\n    font-size: 13px;\n    cursor: pointer;\n\n    &.is-active {\n      background: var(--gh-bg);\n      border-color: var(--gh-border);\n      color: var(--gh-text);\n      font-weight: 600;\n    }\n  }\n\n  &__composer-toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 2px;\n    padding: 4px 8px;\n    border-bottom: 1px solid var(--gh-border-muted);\n    background: var(--gh-bg);\n\n    .ghi-tb-btn {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: 28px;\n      height: 28px;\n      padding: 0;\n      border: none;\n      background: transparent;\n      color: var(--gh-text-muted);\n      border-radius: 4px;\n      cursor: pointer;\n      font-size: 13px;\n\n      &:hover { background: var(--gh-canvas-subtle); color: var(--gh-text); }\n    }\n\n    .ghi-tb-sep {\n      width: 1px;\n      background: var(--gh-border-muted);\n      margin: 4px 4px;\n    }\n  }\n\n  &__composer-body {\n    padding: 12px;\n    position: relative;\n\n    &.is-dragover {\n      outline: 2px dashed var(--gh-link);\n      outline-offset: -6px;\n      background: rgba(9,105,218,0.05);\n    }\n\n    textarea {\n      width: 100%;\n      min-height: 120px;\n      resize: vertical;\n      padding: 8px 10px;\n      border: 1px solid var(--gh-border);\n      border-radius: 6px;\n      font-size: 14px;\n      font-family: ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, 'Liberation Mono', monospace;\n      color: var(--gh-text);\n      background: #fff;\n\n      &:focus {\n        outline: none;\n        border-color: var(--gh-link);\n        box-shadow: 0 0 0 3px rgba(9,105,218,0.2);\n      }\n    }\n  }\n\n  &__composer-hint {\n    padding: 6px 12px 0;\n    font-size: 12px;\n    color: var(--gh-text-muted);\n\n    code {\n      font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n      background: var(--gh-canvas-subtle);\n      padding: 1px 4px;\n      border-radius: 3px;\n    }\n  }\n\n  &__md {\n    word-break: break-word;\n\n    h1, h2 { border-bottom: 1px solid var(--gh-border-muted); padding-bottom: 6px; margin-top: 16px; }\n    h1 { font-size: 1.8em; }\n    h2 { font-size: 1.4em; }\n    h3 { font-size: 1.2em; }\n    p { margin: 0 0 10px; }\n    ul, ol { padding-left: 22px; margin: 0 0 10px; }\n    li input[type=\"checkbox\"] { margin-right: 6px; }\n    blockquote {\n      margin: 0 0 10px;\n      padding: 0 12px;\n      color: var(--gh-text-muted);\n      border-left: 3px solid var(--gh-border);\n    }\n    code {\n      font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n      background: var(--gh-canvas-subtle);\n      padding: 1px 6px;\n      border-radius: 4px;\n      font-size: 0.9em;\n    }\n    pre {\n      background: var(--gh-canvas-subtle);\n      padding: 12px;\n      border-radius: 6px;\n      overflow-x: auto;\n      font-size: 0.9em;\n\n      code { background: transparent; padding: 0; }\n    }\n    table {\n      border-collapse: collapse;\n      margin: 0 0 10px;\n\n      th, td {\n        border: 1px solid var(--gh-border);\n        padding: 4px 10px;\n      }\n      th { background: var(--gh-canvas-subtle); }\n    }\n    img { max-width: 100%; }\n    a { color: var(--gh-link); }\n    hr { border: none; border-top: 1px solid var(--gh-border); margin: 16px 0; }\n  }\n\n  &__composer-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    padding: 0 12px 12px;\n  }\n\n  &__composer-attach {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 10px;\n    padding: 8px 12px;\n    border-top: 1px dashed var(--gh-border-muted);\n    background: var(--gh-canvas-subtle);\n    font-size: 12px;\n    color: var(--gh-text-muted);\n  }\n\n  &__composer-attach-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  &__composer-attach-item {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 2px 8px;\n    background: #fff;\n    border: 1px solid var(--gh-border);\n    border-radius: 4px;\n    font-size: 12px;\n    color: var(--gh-text);\n\n    a { color: var(--gh-link); }\n  }\n\n  &__composer-attach-thumb {\n    display: inline-block;\n    border: 1px solid var(--gh-border);\n    border-radius: 6px;\n    overflow: hidden;\n    background: #fff;\n\n    img {\n      display: block;\n      max-width: 140px;\n      max-height: 100px;\n      object-fit: cover;\n    }\n\n    &:hover { border-color: var(--gh-link); }\n  }\n\n  .ghi-att-thumb {\n    display: inline-block;\n    border: 1px solid var(--gh-border);\n    border-radius: 4px;\n    overflow: hidden;\n    line-height: 0;\n\n    img {\n      display: block;\n      max-width: 40px;\n      max-height: 40px;\n      object-fit: cover;\n    }\n  }\n\n  &__btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 5px 14px;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    border: 1px solid var(--gh-border);\n    background: var(--gh-btn-bg);\n    color: var(--gh-text);\n    line-height: 1.5;\n\n    &:hover { background: var(--gh-btn-hover); }\n    &:disabled { opacity: 0.6; cursor: not-allowed; }\n\n    &.is-primary {\n      background: #1f883d;\n      color: #fff;\n      border-color: rgba(27,31,36,0.15);\n\n      &:hover { background: #1a7f37; }\n    }\n\n    &.is-purple {\n      background: #8250df;\n      color: #fff;\n      border-color: rgba(27,31,36,0.15);\n\n      &:hover { background: #6e40c9; }\n    }\n\n    &.is-danger {\n      color: var(--gh-danger);\n\n      &:hover { background: #ffebe9; border-color: #ffcecb; }\n    }\n  }\n\n  .ghi-label {\n    display: inline-flex;\n    align-items: center;\n    padding: 0 8px;\n    height: 22px;\n    border-radius: 2em;\n    font-size: 12px;\n    font-weight: 500;\n    border: 1px solid transparent;\n    white-space: nowrap;\n    margin: 2px 4px 2px 0;\n  }\n\n  .ghi-assignee-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 6px;\n\n    .ghi-assignee-name {\n      font-size: 13px;\n      color: var(--gh-text);\n    }\n  }\n\n  .ghi-checklist-item {\n    display: flex;\n    align-items: flex-start;\n    gap: 6px;\n    padding: 4px 0;\n    font-size: 13px;\n\n    label { cursor: pointer; }\n    .is-done { text-decoration: line-through; color: var(--gh-text-muted); }\n  }\n\n  .ghi-attachment {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 4px 0;\n    font-size: 13px;\n    color: var(--gh-link);\n\n    a { color: inherit; }\n\n    .ghi-att-del {\n      margin-left: auto;\n      color: var(--gh-text-muted);\n      background: transparent;\n      border: none;\n      cursor: pointer;\n      padding: 0 4px;\n\n      &:hover { color: var(--gh-danger); }\n    }\n  }\n}\n\n// Mention chips inside rendered comments and task descriptions.\n.gh-issue {\n  .mention {\n    background: #ddf4ff;\n    color: #0969da;\n    padding: 0 4px;\n    border-radius: 4px;\n    font-weight: 600;\n    text-decoration: none;\n    display: inline-block;\n    line-height: 1.4;\n\n    &:hover { background: #b6e3ff; text-decoration: none; }\n  }\n}\n\n// CKEditor 4 autocomplete popover for @mentions — rendered at <body> by CKEditor,\n// so the selectors are global rather than nested under .gh-issue.\n.cke_autocomplete_panel {\n  background: #fff;\n  border: 1px solid #d0d7de;\n  border-radius: 6px;\n  box-shadow: 0 8px 24px rgba(140, 149, 159, 0.2);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;\n  min-width: 220px;\n  max-height: 240px;\n  overflow-y: auto;\n  padding: 4px 0;\n  z-index: 10010; // above antd Drawer (z-index ~1000)\n}\n\n.ck-mention-item {\n  list-style: none;\n  padding: 6px 12px;\n  font-size: 13px;\n  color: #1f2328;\n  cursor: pointer;\n\n  &.cke_autocomplete_selected,\n  &:hover {\n    background: #ddf4ff;\n    color: #0969da;\n  }\n\n  .ck-mention-avatar {\n    font-weight: 500;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
